<template>
  <div class="oneYuan">
    <div class="header">
      <div class="wrap-inner">
        <h1 class="fr logo">大智慧</h1>
      </div>
    </div>
    <!-- <div class="banner">
      <div class="wrap-inner">
        <div class="login">
          <div class="login-wrap">
            <ul class="login-list">
              <li>
                <div class="ipt-wrap">
                  <input type="text" placeholder="请输入中文称呼" v-model.trim="realName" />
                </div>
              </li>
              <li>
                <div class="ipt-wrap">
                  <input type="text" placeholder="手机号 用以接收开通短信" v-model.number="mobile" />
                </div>
              </li>
            </ul>
            <a href="###" class="login-btn" @click="buy()" :class="selectRules?'':'disabled'">立即购买</a>
          </div>
          <div class="login-rules">
            <input type="checkbox" checked="checkbox" id="cbox" />
            <label for="cbox" @click="selectRules=!selectRules">我已仔细阅读相关协议</label>
            <a href="https://i.gw.com.cn/UserCenter/rulesregister.html" target="_blank">《使用软件许可协议》</a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="top-mod">
      <div class="wrap">
          <h1>大智慧「启航版」</h1>
          <p class="tip1">快速入门，炒股利器，纵横股海，一站式解决炒股难题</p>
          <p class="tip2">极速行情 · 智能选股 · 专业指标 · 一网打尽</p>

          <div class="price">
            <span class="l-fixtip">
              <em class="l-smallf">首月</em>
              <span>限时<em></em>元</span>
            </span>
            <span class="f-thought">￥598 元/年</span><a href="#" class="btn-buy" @click="payFormVisible = true">立刻购买</a>
          </div>
          <p class="tip3">咨询热线：021-20219999</p>
      </div>
    </div>
    <div class="main">
      <div v-for="(row,rowindex) in pageData" class="row" :class="'row'+(rowindex+1)">
        <div class="ctn-box">
          <div class="title-box">
            <h3>{{row.title}}</h3>
            <p>{{row.titleBtm}}</p>
          </div>
          <div class="clearfix character-list" v-if="row.characterList" :class="'f'+row.characterList.length">
            <span class="ct-item" v-for="pitem in row.characterList">
              <p v-for="text in pitem">{{text}}</p>
            </span>
          </div>
          <div class="block">
            <el-carousel trigger="click" height="682px">
              <el-carousel-item v-for="(item,index) in row.carouselData" :key="index">
                <img :src="require('../../assets/images/product/338/carousel/c0'+(rowindex+1)+'/img'+item)"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="mod mod-darkred">
      <div class="wrap-inner">
        <p class="tips">购买须知: 大智慧启航版，1元免费体验，部分特权功能自购买日起30天有效 尽快登录使用哦！每个大智慧帐号、每个支付帐号，仅限购买一次；同一个支付帐号购买多次的，第二次起软件使用时长为7天! 本活动时间1月1日-12月31日</p>
        <div class="footer-informs">
          <span>投资有风险 入市需谨慎 </span>
          <span>上海大智慧信息科技有限公司对本活动拥有解释权</span>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="" :visible.sync="payFormVisible" top="" class="dialog-pay" @close="resetForm">
      <div slot="title" class="dialog-title">
      	<div class="tle-ctn">
          <p class="sm-top">首月</p>
          <p>限时<em class="num-box">1</em>元体验<span class="pc-tip">电脑版</span></p>
        </div>
      </div>
    	<el-form :rules="rules" :model="ruleForm" ref="ruleForm">
    		<el-form-item prop="realName">
    			<el-input v-model="ruleForm.realName" autocomplete="off"  placeholder="请输入中文昵称"></el-input>
    		</el-form-item>
        <el-form-item prop="mobile">
        	<el-input v-model="ruleForm.mobile" autocomplete="off"  placeholder="请输入手机号,用于开通接通短信"></el-input>
        </el-form-item>
        <el-form-item >
        	<el-checkbox v-model="ruleForm.selectRules">
        	   我已仔细阅读相关协议<a href="https://i.dzh.com.cn/UserCenter/rulesregister.html" class="link">《使用软件许可协议》</a>
        	</el-checkbox>
        </el-form-item>
        <el-form-item class="dialog-footer">
          <p class="phone-tip">咨询热线：021-20219999</p>
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          <div class="btn-box">
            <el-button @click="payFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="buy('ruleForm')">立即购买</el-button>
          </div>
        </el-form-item>
    	</el-form>
    	<!-- <div slot="footer" class="dialog-footer">
        <p class="phone-tip">咨询热线：021-20219999</p>
        <div class="btn-box">
          <el-button @click="payFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="buy">立即购买</el-button>
        </div>

    	</div> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: function() {
    var that = this
    var validateName = function(rule, value, callback) {
      if (value != ''&&!that.$validate.checkChineseWord(value)){
        callback(new Error('姓名必须是中文'));
      }else{
        callback();
      }
    }
    var validatePhone = function(rule, value, callback ){
      if (value != ''&&!that.$validate.checkPhone(value)){
        callback(new Error('手机号格式错误'));
      }else{
        callback();
      }
    }
    return {
      s: this.$route.query.s,
      queryParams: "",
      payloadParams: { productId: 338, month: 1 },

      pageData:[
        {
          title:'极速行情，全景看盘',
          titleBtm:'专业的看盘界面，只为更快更好的及至看盘体验',
          carouselData:['1.png','2.png','3.png']
        }, {
          title:'AI决策：四维战法',
          titleBtm:'通过对价量筹码资金等多种分析方法的融合。过滤单一指标发出失真信号的场景。',
          characterList:[
            ['黄金波段第一时间','揭示顶背离和底背离'],
            ['市场热度多空热度一手掌握'],
            ['GDX深度挖掘','活跃资金的市场行为'],
            ['黄金狙击变盘信号早知道']
          ],
          carouselData:['1.jpg','2.jpg','1.jpg','2.jpg']
        }, {
          title:'智能选股',
          titleBtm:'基本面、技术面、资金面、消息面；一句话、一个关键词即可全局搜索',
          carouselData:['1.png','2.png','1.png','2.png']
        }, {
          title:'新闻资讯数据全覆盖',
          titleBtm:'汇聚宏观行业政策、机构观点、主力资金动向、个股分析等高投资价值资讯数据。',
          characterList:[
            ['宏观、行业资讯、','个股F10、北向资金'],
            ['7*24小时不间断，','及时、专业的财经数据资讯'],
            ['个股公告研报秒更新']
          ],
          carouselData:['1.png','2.png','3.png']
        }, {
          title:'技术大讲堂',
          titleBtm:'软件功能不会用？哪里不会点哪里，视频详解产品热门功能',
          carouselData:['1.jpg','2.png','1.jpg','2.png']
        }
      ],
      payFormVisible:false,
      ruleForm:{
        realName: "",
        mobile: "",
        selectRules: true,
      },
      rules: {
        realName: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min:1,max: 7, message: '姓名长度不能超过7位', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    var index = window.location.href.indexOf("?");
    if (index > -1) {
      this.queryParams = window.location.href.substring(index);
    }
    if(!this.s){
      this.s = "";
    }
  },
  methods: {
    buy(formName) {
      var that = this
      if (!this.ruleForm.selectRules) {
        this.$global.alert("请仔细阅读软件使用协议");
        return false;
      }else{
        this.$refs[formName].validate(function(valid) {
          if (valid) {
            that.payloadParams.realName = that.ruleForm.realName;
            that.payloadParams.mobile = that.ruleForm.mobile;
            that.$post("/activity/oybInit" + that.queryParams, that.payloadParams)
              .then(response => {
                if (response.code === 0) {
                  that.$storage.saveUserName(response.data);
                  that.$router.push("/order/confirm/338/1dzhpfo?s=" + that.s);
                } else if (response.code === 1001) {
                  that.$storage.saveUserName(response.data.userName);
                  that.$router.push("/order/pay/" + response.data.id);
                } else if (response.code != 100) {
                  that.$global.alert(response.msg);
                }
              })
              .catch(err => {
                that.$global.alertError();
              });
          } else {

            return false;
          }
        });
      }


    },
    resetForm(){
      this.$refs.ruleForm.resetFields()
    },
    scroll() {
      window.scrollTo(0, 400);
    },
    link () {
      let href = 'http://l2ad.dzh.com.cn/xwzz/web/index.php?r=activity/level2/index&obj=SZ002109'
      window.open(href, "_blank")
    }
  }
};
</script>

<style lang="scss" scoped>
$url:'../../assets/images/product/338/';
$urloyb:'../../assets/images/activity/1yuan/oyb338/';
/deep/.oneYuan{
  input::-webkit-input-placeholder {
    color: #ccc;
  }
  .wrap-inner {
    max-width: 1200px;
    margin: 0 auto;
    width: 80%;
  }
  .header {
    background: #fff;
    padding: 15px 0 56px;
    h1 {
      background: url("../../assets/images/activity/1yuan/logo.png") no-repeat 0 0;
      width: 150px;
      height: 47px;
      text-indent: -999px;
      overflow: hidden;
    }
  }
  .top-mod{
    width: 100%;
    height: 759px;
    background: url($url+'bg.jpg')no-repeat center /1920px;
    .wrap{
      width: 1200px;
      margin: 0 auto;
      padding-top: 115px;
      box-sizing: border-box;
      h1{
        font-size: 50px;
        line-height: 53px;
        color: #fff;
      }
      .pc-tip{
        font-size: 23px;
        color: #fff;
        width: 87px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        vertical-align: 11px;
        margin-left: 6px;
        background-color: #17aaff;
      }

      p{
        &.tip1{
          font-size: 24px;
          line-height: 24px;
          margin-top: 20px;color: #fff;
        }
        &.tip2{
		  display:inline-block;
          min-width: 501px;
          height: 50px;
          padding: 0 10px;
          border-radius: 50px;
          border: 1px solid #31cfff;
          font-size: 22px;
          text-align: center;
          box-sizing: border-box;
          line-height: 50px;
          color: #31cfff;
          margin-top: 35px;
          margin-bottom: 118px;
        }
        &.tip3{
          margin-top: 21px;
          font-size: 22px;
          line-height: 22px;
          margin-bottom: 24px;
          color: #fff;
          padding-left: 30px;
          background: url($url+'icon-phone.png')no-repeat left center/22px;
        }
      }
      .price{
        width: 380px;
        height: 72px;
        border-radius: 6px;
        background-color: rgba(255,255,255,0.1);
        border: 1px solid #fff;
        box-sizing: border-box;
        font-size: 30px;color: #fff;
        line-height: 70px;
        text-align: left;
        padding-left: 18px;
        background: url($urloyb+'btnbg.png')no-repeat center/100%;
        box-sizing: border-box;
        position: relative;
        .l-fixtip{
          width: 198px;
          height: 62px;
          line-height: 62px;
          background-color: #fff;
          position: absolute;
          left: -1px;
          top: -46px;
          border-radius: 10px 10px 10px 0;
          .l-smallf{
            color: #31cfff;
            font-size: 16px;
            display: inline-block;
            width: 18px;
            line-height: 18px;
            padding-left: 20px;
            vertical-align: middle;
          }
          &>span{
            font-size: 32px;
            font-weight: bold;
            color: #15c8ff;
            &>em{
              display: inline-block;
              width: 32px;
              height: 31px;
              border-radius: 6px;
              background:#15c8ff url($urloyb+'one.png')no-repeat center;
              vertical-align: middle;
              margin: 0 2px;
              vertical-align: -5px;
            }
          }
        }
        .f-thought{
          position: relative;
          text-decoration: line-through;
        }
      }
      .btn-buy{
        display: inline-block;
        width: 191px;
        height: 100%;
        color: #fff;
        text-align: center;
        float: right;
        position: relative;
        &::before{
          content: '';
          position: absolute;
          width: 1px;
          height: 23px;
          background-color: #fff;
          left: 12px;
          top:50%;
          margin-top: -11px;
        }
        &:hover{
          opacity: 0.85;
        }
      }
    }
  }
  .main {
    margin: 0 auto;
    padding: 0;
    .row {
      h3 {

      }
      .ctn-box{
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 106px;
        .title-box{
          text-align: center;
          padding-top: 71px;
          h3{
            color: #222222;
            font-size: 40px;
            height: 58px;
            line-height: 40px;
            text-align: center;
            box-sizing: border-box;
            padding-top: 18px;
            background: url($url+'titlebg.png')no-repeat center/636px;
          }
          p{
            padding-top: 16px;
            font-size: 20px;
            color: #666666;
          }
        }
        .character-list{
          margin-top: 42px;
          margin-bottom: 44px;
          display: flex;
          .ct-item{
            width: 372px;
            height: 253px;
            border-radius: 10px;
            background-color: #fff;
            box-shadow: 0px 15px 40px rgba(0,0,0,0.2);
            padding-top: 27px;
            position: relative;
            box-sizing: border-box;
            display: inline-block;
            float: left;
            &:last-child{
              margin-right: 0;
            }

            margin-right: 42px;

            &:before{
              content: '';
              width: 120px;
              height: 120px;
              border-radius: 120px;
              display: block;
              margin: 0 auto 16px;
            }
            p{
              font-size: 20px;
              color: #30303f;
              text-align: center;
              line-height: 30px;
            }
          }
          &.f4{
            .ct-item{
              width: 278px;
              margin-right: 30px;
              &:last-child{
                margin-right: 0;
              }
            }
          }

        }
        .block{
          margin-top: 40px;
          .el-carousel{
            width: 1200px;
            height: 682px;
            border-radius: 6px;
            border: 4px solid #fff;
            box-shadow: 0px 15px 40px rgba(0,0,0,0.2);
            .el-carousel__item{
              img{
                width: 100%;
                height: 100%;
              }
            }
            .el-carousel__arrow{
              width: 85px;
              height: 85px;
              border-radius: 85px;
              background: transparentize(#555c6f, .7);
              i{
                font-size: 40px;
              }
              &:hover{
                background: transparentize(#555c6f, .6);
              }
            }
            .el-carousel__indicators{
              display: none;
            }
          }
        }
      }
      &.row2,&.row4{
        background: url($url+'bg2.jpg')no-repeat center/1920px;
        .ctn-box{
          padding-bottom: 95px;
        }
      }
      &.row2{
        .character-list{
          .ct-item{
            &:before{
              content: '';
              display: block;
              background-image: url($url+'icons1.png');
              background-size: 1042px;
              background-repeat: no-repeat;
            }
            &:nth-child(2){
              &:before{
                background-position: -313px 4px;
              }
            }
            &:nth-child(3){
              &:before{
                background-position: -617px -4px;
              }
            }
            &:nth-child(4){
              &:before{
                background-position: -923px 0px;
              }
            }
          }
        }
      }
      &.row4{
        .character-list{
          .ct-item{
            &:before{
              content: '';
              display: block;
              background-image: url($url+'icons2.png');
              background-size: 944px;
              background-repeat: no-repeat;
            }
            &:nth-child(2){
              &:before{
                background-position: -416px -4px;
              }
            }
            &:nth-child(3){
              &:before{
                background-position: -824px 0px;
              }
            }
          }
        }
      }
    }
  }
  .mod-darkred {
    background: #183588;
    padding-bottom: 16px;
    padding-top: 16px;
    .tips {
      color: #8fabe2;
      font-size: 22px;
      font-size: 14px;
    }
    .footer-informs {
      font-size: 22px;
      font-size: 14px;
      color: #8fabe2;
      margin-top: 18px;
      span {
        margin-right: 14px;
      }
    }
  }
  .dialog-pay{
    .el-dialog{
      width: 750px;
      //height: 785px;
      position: relative;
      border-radius: 35px;
      padding: 204px 52px 42px;
      margin: 50px auto;
      box-sizing: border-box;
      background:#fff url($urloyb+'dialogbg.png')no-repeat center top /100%;
      .el-dialog__header{
        padding: 0;
        .el-dialog__title,.el-dialog__close{
          display: none;
        }

      }
      .dialog-title{
        position: absolute;
        top: 48px;
        width: 100%;
        padding-left: 108px;
        box-sizing: border-box;
        .tle-ctn{
          p{
            font-size: 55px;
            color: #fff;
            &.sm-top{
              font-size: 27px;
              color: rgba(255,255,255,0.6);
            }
            .num-box{
              width: 53px;
              height: 53px;
              display: inline-block;
              border-radius: 6px;
              vertical-align: -6px;
              margin: 0 4px;
              background: #fff url($urloyb+"dialog-numone.png")no-repeat center;
            }
            .pc-tip{
              font-size: 23px;
              color: #fff;
              width: 87px;
              height: 42px;
              line-height: 42px;
              text-align: center;
              border-radius: 6px;
              display: inline-block;
              vertical-align: 11px;
              margin-left: 6px;
              background-color: #17aaff;
            }
          }
        }
      }
      .el-dialog__body{
        padding: 0;
        .el-form{
          .el-form-item{
            margin-bottom: 50px;
            .el-form-item__content{
              .el-input{
                input{
                  height: 98px;
                  background-color: #f4f7fc;
                  border-radius: 12px;
                  font-size: 30px;
                  color: #434343;
                  padding: 0 28px;
                  border: 0;
                  &::-webkit-input-placeholder {
                    color: #999;
                  }
                }
              }
              .el-checkbox{
                .el-checkbox__input{
                  vertical-align: -6px;
                  .el-checkbox__inner{
                    width: 33px;
                    height: 33px;

                    &:after{
                      height: 18px;
                      left: 10px;
                      width: 10px;
                      border: 3px solid #FFF;
                      border-radius: 2px;
                      border-left: 0;
                      border-top: 0;
                    }

                  }
                  &.is-checked{

                    .el-checkbox__inner{
                      background-color: #007eff;
                      border-color: #007eff;
                    }
                  }
                }
                .el-checkbox__label{
                  color: #434343;
                  font-size: 30px;
                  .link{
                    color: #007eff;
                  }
                }
              }
              .el-form-item__error{
                font-size: 23px;
                color: #ff3a3a;
              }
            }
            &:last-child{
              margin-bottom: 20px;
            }
            &.dialog-footer{
              .phone-tip{
                color: #434343;
                text-align: left;
                font-size: 30px;
                padding-top: 8px;
                margin-bottom: 43px;
              }
              .btn-box{
                text-align: left;
                .el-button{
                  width: 310px;
                  height: 84px;
                  display: inline-block;
                  font-size: 27px;
                  text-align: center;
                  color: #333333;
                  &.el-button--primary{
                    background-color: #007eff;
                    color: #fff;
                    &:hover{
                      opacity: 0.85;
                    }
                  }
                }
              }

            }
          }
        }
      }

    }
  }
  // @media screen and (max-width: 1480px) {
  //   .mod-darkred {
  //     .tips {
  //       font-size: 14px;
  //     }
  //     .footer-informs {
  //       font-size: 14px;
  //     }
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/OYB338.vue